export class NICEUserPerformance {

    agentId: number;
    teamId: number;
    agentOffered: number;
    inboundHandled: number;
    inboundTime: string;
    inboundTalkTime: string;
    inboundAvgTalkTime: string;
    outboundHandled: number;
    outboundTime: string;
    outboundTalkTime: string;
    outboundAvgTalkTime: string;
    totalHandled: number;
    totalTalkTime: string;
    totalAvgTalkTime: string;
    totalAvgHandleTime: string;
    consultTime: string;
    availableTime: string;
    unavailableTime: string;
    acwTime: string;
    refused: number;
    percentRefused: number;
    loginTime: string;
    workingRate: number;
    occupancy: number;
    availableSeconds: number;
    unavailableSeconds: number;
    outboundSeconds: number;
    inboundSeconds: number;
    loginSeconds: number;

    constructor(jsonData?) {
        this.agentId = jsonData.agentId;
        this.teamId = jsonData.teamId;
        this.agentOffered = jsonData.agentOffered;
        this.inboundHandled = jsonData.inboundHandled;
        this.inboundTime = this.convert_PT_Time(jsonData.inboundTime);
        this.inboundTalkTime = jsonData.inboundTalkTime;
        this.inboundAvgTalkTime = jsonData.inboundAvgTalkTime;
        this.outboundHandled = jsonData.outboundHandled;
        this.outboundTime = this.convert_PT_Time(jsonData.outboundTime);
        this.outboundTalkTime = jsonData.outboundTalkTime;
        this.outboundAvgTalkTime = jsonData.outboundAvgTalkTime;
        this.totalHandled = jsonData.totalHandled;
        this.totalTalkTime = jsonData.totalTalkTime;
        this.totalAvgTalkTime = jsonData.totalAvgTalkTime;
        this.totalAvgHandleTime = jsonData.totalAvgHandleTime;
        this.consultTime = jsonData.consultTime;
        this.availableTime = this.convert_PT_Time(jsonData.availableTime);
        this.unavailableTime = this.convert_PT_Time(jsonData.unavailableTime);
        this.acwTime = jsonData.acwTime;
        this.refused = jsonData.refused;
        this.percentRefused = jsonData.percentRefused;
        this.loginTime = this.convert_PT_Time(jsonData.loginTime);
        this.workingRate = jsonData.workingRate;
        this.occupancy = jsonData.occupancy;
        this.availableSeconds = this.convertTime2Seconds(this.availableTime);
        this.unavailableSeconds = this.convertTime2Seconds(this.unavailableTime);
        this.outboundSeconds = this.convertTime2Seconds(this.outboundTime);
        this.inboundSeconds = this.convertTime2Seconds(this.inboundTime);
        this.loginSeconds = this.convertTime2Seconds(this.loginTime);

    }
    convert_PT_Time(ptTime: string): string {
        let D = '';
        let H = '00';
        let M = '00';
        let S = '00';
        let tempTime = ptTime.replace('PT', '');
        if (tempTime.indexOf('D') >= 0){
            D = tempTime.substr(0, tempTime.indexOf('D'));
            tempTime = tempTime.replace(D + 'D', '');
        }
        if (tempTime.indexOf('H') >= 0){
            H = tempTime.substr(0, tempTime.indexOf('H'));
            tempTime = tempTime.replace(H + 'H', '');
        }
        if (tempTime.indexOf('M') >= 0){
            M = tempTime.substr(0, tempTime.indexOf('M'));
            tempTime = tempTime.replace(M + 'M', '');
        }
        if (tempTime.indexOf('S') >= 0){
            S = tempTime.substr(0, tempTime.indexOf('S'));
        }
        if (D !== ''){
            return D + 'Days ' + this.formatData(H) + ':' + this.formatData(M) + ':' + this.formatData(Math.floor(+S).toString());
        }
        return this.formatData(H)+ ':' + this.formatData(M) + ':' + this.formatData(Math.floor(+S).toString());
    }

    formatData(str: string): string {
        if (str.length === 1 ) {
            return '0' + str;
        }
        return str;
    }

    convertTime2Seconds(dTime: string): number {
        let totalSeconds = 0;
        if (dTime.indexOf('Days') >= 0) {
            const D = dTime.substr(0, dTime.indexOf('Days'));
            totalSeconds = +D * 86400;
            dTime = dTime.replace(D + 'Days', '');
        }
        const H = dTime.substr(0, dTime.indexOf(':'));
        totalSeconds = totalSeconds + +H * 3600;
        dTime = dTime.replace(dTime.substr(0, dTime.indexOf(':') + 1), '');

        const M = dTime.substr(0, dTime.indexOf(':'));
        totalSeconds = totalSeconds + +M * 60;
        dTime = dTime.replace(dTime.substr(0, dTime.indexOf(':') + 1), '');
        return totalSeconds + +dTime;
    }
}
